import { FSCheckout } from 'freemius-checkout-js';

// instantiate
const fsCheckout = new FSCheckout({
    plugin_id:  '11507',
    public_key: 'pk_db84e7b85216108baf2a989db0b9c',
});

// Call the API
document.querySelector('#personal-yearly').addEventListener('click', (e) => {
  e.preventDefault();
  // call the open method
  fsCheckout.open({
    // plan
    plan_id: 19603,
    // number of sites
    licenses: 1,
    // billing cycles
    billing_cycle: 'annual',
  });
});

// Call the API
document.querySelector('#business-yearly').addEventListener('click', (e) => {
  e.preventDefault();
  // call the open method
  fsCheckout.open({
    // plan
    plan_id: 19610,
    // number of sites
    licenses: 3,
    // billing cycles
    billing_cycle: 'annual',
  });
});

// Call the API
document.querySelector('#agency-yearly').addEventListener('click', (e) => {
  e.preventDefault();
  // call the open method
  fsCheckout.open({
    // plan
    plan_id: 19611,
    // number of sites
    licenses: 10,
    // billing cycles
    billing_cycle: 'annual',
  });
});

// Call the API
document.querySelector('#personal-lifetime').addEventListener('click', (e) => {
  e.preventDefault();
  // call the open method
  fsCheckout.open({
    // plan
    plan_id: 19612,
    // number of sites
    licenses: 1,
    // billing cycles
    billing_cycle: 'lifetime',
  });
});



// Call the API
document.querySelector('#business-lifetime').addEventListener('click', (e) => {
  e.preventDefault();
  // call the open method
  fsCheckout.open({
    // plan
    plan_id: 19613,
    // number of sites
    licenses: 3,
    // billing cycles
    billing_cycle: 'lifetime',
  });
});


// Call the API
document.querySelector('#agency-lifetime').addEventListener('click', (e) => {
  e.preventDefault();
  // call the open method
  fsCheckout.open({
    // plan
    plan_id: 19614,
    // number of sites
    licenses: 10,
    // billing cycles
    billing_cycle: 'lifetime',
  });
});